import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

export interface FqTunnel {
  /** Nome dell'interfaccia/tunnel (es. "biz-internet", "TO_MPLS1"). */
  name: string
  /** Stato del tunnel: `up` (success) oppure `down` (danger). */
  status: string
}

/**
 * Tabella compatta e uniforme per lo stato dei tunnel.
 * Unico punto di verita' per i dialog "Tunnel Status" (speedtest, workflow, NRD).
 * `up` = success (verde), `down` = danger (rosso); righe zebra.
 *
 * @example
 * <fq-tunnel-status [tunnels]="tunnel" />
 */
@Component({
  selector: 'fq-tunnel-status',
  standalone: true,
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <table class="fq-tunnel-table">
      <thead>
        <tr>
          <th class="text-left">Tunnel</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        @if (tunnels().length === 0) {
          <tr>
            <td colspan="2" class="fq-tunnel-empty">Connection down</td>
          </tr>
        }
        @for (tunnel of tunnels(); track tunnel.name) {
          <tr>
            <td class="fq-tunnel-name">{{ tunnel.name }}</td>
            <td>
              <span class="fq-tunnel-state"
                [class.fq-tunnel-up]="isUp(tunnel)"
                [class.fq-tunnel-down]="!isUp(tunnel)">
                <fa-icon [icon]="isUp(tunnel) ? ['fas', 'circle-up'] : ['fas', 'circle-down']" />
                <span>{{ isUp(tunnel) ? 'Up' : 'Down' }}</span>
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  `
})
export class FqTunnelStatusComponent {
  readonly tunnels = input<FqTunnel[]>([])

  isUp (tunnel: FqTunnel): boolean {
    return String(tunnel?.status ?? '').toLowerCase() === 'up'
  }
}
